/* =========================
   ROUTES
========================= */
export const ROUTES = {
  PEER_GROUP_FORUMS: "/peer-group-forums",
  ORGANISATIONS_REPRESENTED: "/organisations-represented",
};

/* =========================
   HERO SECTION
========================= */
export const HERO_CONTENT = {
  label: {
    primary: "Peer group forum",
    secondary: "Organizations represented",
  },
  headline: "Bringing together leaders from every industry",
};

/* =========================
   DESCRIPTION SECTION
========================= */
export const DESCRIPTION_CONTENT = {
  highlight: "IMA unites senior leaders from diverse industries,",
  text: `building a powerful network of experience, insight, and collaboration.
Our members represent leading organizations across sectors—driven by a
shared commitment to learning, dialogue, and growth. Here are the
organizations represented in our community...`,
};

/* =========================
   MEMBER COMPANIES SECTION
========================= */
export const MEMBER_COMPANIES_CONTENT = {
  title: "Meet the member companies in your forum",
  description: "A partial list of our members, forum wise.",
};

/* =========================
   CTA SECTION
========================= */
export const CTA_CONTENT = {
  title: "Join your peers in an IMA Forum",
  description: `Join a high-value network, share ideas and knowledge.
Access research and attend events tailored specifically to your forum.`,
  buttonText: "Explore peer group forums",
};
